module.exports = __webpack_public_path__ + "images/_/assets/images/pdf_cabecalho_rig.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdf_cabecalho_rig.png
// module id = ./src/assets/images/pdf_cabecalho_rig.png
// module chunks = 1